import { Component, OnInit,AfterViewInit,ViewChild,ViewEncapsulation } from '@angular/core';
import { ModalService } from '../helper/modal';
import { ElementService } from '../service/';
import { environment } from '@environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { Observable, Subject } from 'rxjs';;
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';


@Component({
    selector: 'mission',
    templateUrl: './mission.component.html',
    styleUrls: ['./mission.component.css'],
    encapsulation: ViewEncapsulation.None
  })
  export class MissionComponent implements OnInit,AfterViewInit {

    app_name = environment.app_name
    apiUrl:string =environment.apiUrl
    html:string = '<p style="text-align: center"><span style="background-color: transparent; font-size: 1rem;">test</span></p>'
    constructor() { }

    ngOnInit(): void {

      }
      ngAfterViewInit() {
        const exampleDiv2 = document.getElementById('example2');

        exampleDiv2.innerHTML = this.html
      }



}
